import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { closingLines } from '../data/offer';
export function ClosingSection() {
  return <section className="bg-green-900 py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-51" data-mp="12slodzpkpx35">
      <div className="mx-auto max-w-4xl px-4" data-id="element-52" data-mp="xtquo2q2io49">
        <div className="text-center" data-id="element-53" data-mp="xsz9zmy0easr">
          <h2 id="closing-title" className="text-balance text-3xl font-extrabold leading-tight text-stone-50 sm:text-4xl" data-id="element-54" data-mp="xw3lz6hpuatz">
            Next Monday you can keep improvising…
          </h2>
          <p className="mt-4 text-2xl font-extrabold text-amber-400 sm:text-3xl" data-id="element-55" data-mp="17rok2tjnyqyg">
            Or you can enter your classroom fully prepared starting today.
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-56" data-mp="1hi9o4wi3wnor">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 rounded-lg border-l-4 border-amber-500 bg-green-950/50 px-4 py-3 text-sm font-semibold text-stone-50" data-id="element-57" data-mp="1vhsjsptqe6k6" data-mpi={index}>
              <ChevronRightIcon className="h-4 w-4 shrink-0 text-amber-400" aria-hidden="true" data-id="element-58" data-mp="2gcn05xtzoppv" />
              {line}
            </motion.li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-59" data-mp="2l93zlo6n2qi9">
          <p className="leading-relaxed text-green-100" data-id="element-60" data-mp="2q9055ruzipzx">
            This teacher ready won't make you a better educator. You're already an excellent educator.
          </p>
          <p className="mt-3 text-lg font-bold text-stone-50" data-id="element-61" data-mp="300mbb9sgtyvt">
            What this teacher ready does is give you the time and tools so that excellence shows in every single class.
          </p>
        </div>
      </div>
    </section>;
}